export default {"src":"/_next/static/media/app-play-store-grey800.65486785.svg","height":40,"width":343,"blurWidth":0,"blurHeight":0};